import { render, staticRenderFns } from "./StatDialog.vue?vue&type=template&id=5aa959d0"
import script from "./StatDialog.vue?vue&type=script&lang=js"
export * from "./StatDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports